
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// here you put all the js you want.
var $03d2e5de506255f0$exports = {};
!function(e, t) {
    $03d2e5de506255f0$exports = t();
}($03d2e5de506255f0$exports, function() {
    "use strict";
    const e = "undefined" != typeof window, t = e && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), a = e && window.devicePixelRatio > 1, n = {
        elements_selector: ".lazy",
        container: t || e ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, s = (e)=>Object.assign({}, n, e), l = function(e, t) {
        let a;
        const n = "LazyLoad::Initialized", s = new e(t);
        try {
            a = new CustomEvent(n, {
                detail: {
                    instance: s
                }
            });
        } catch (e) {
            a = document.createEvent("CustomEvent"), a.initCustomEvent(n, !1, !1, {
                instance: s
            });
        }
        window.dispatchEvent(a);
    }, o = "src", r = "srcset", i = "sizes", d = "poster", c = "llOriginalAttrs", _ = "data", u = "loading", g = "loaded", b = "applied", h = "error", m = "native", p = "data-", f = "ll-status", v = (e, t)=>e.getAttribute(p + t), E = (e)=>v(e, f), I = (e, t)=>((e, t, a)=>{
            const n = p + t;
            null !== a ? e.setAttribute(n, a) : e.removeAttribute(n);
        })(e, f, t), y = (e)=>I(e, null), k = (e)=>null === E(e), A = (e)=>E(e) === m, L = [
        u,
        g,
        b,
        h
    ], w = (e, t, a, n)=>{
        e && "function" == typeof e && (void 0 === n ? void 0 === a ? e(t) : e(t, a) : e(t, a, n));
    }, x = (t, a)=>{
        e && "" !== a && t.classList.add(a);
    }, C = (t, a)=>{
        e && "" !== a && t.classList.remove(a);
    }, O = (e)=>e.llTempImage, M = (e, t)=>{
        if (!t) return;
        const a = t._observer;
        a && a.unobserve(e);
    }, z = (e, t)=>{
        e && (e.loadingCount += t);
    }, N = (e, t)=>{
        e && (e.toLoadCount = t);
    }, T = (e)=>{
        let t = [];
        for(let a, n = 0; a = e.children[n]; n += 1)"SOURCE" === a.tagName && t.push(a);
        return t;
    }, R = (e, t)=>{
        const a = e.parentNode;
        a && "PICTURE" === a.tagName && T(a).forEach(t);
    }, G = (e, t)=>{
        T(e).forEach(t);
    }, D = [
        o
    ], H = [
        o,
        d
    ], V = [
        o,
        r,
        i
    ], F = [
        _
    ], j = (e)=>!!e[c], B = (e)=>e[c], J = (e)=>delete e[c], S = (e, t)=>{
        if (j(e)) return;
        const a = {};
        t.forEach((t)=>{
            a[t] = e.getAttribute(t);
        }), e[c] = a;
    }, P = (e, t)=>{
        if (!j(e)) return;
        const a = B(e);
        t.forEach((t)=>{
            ((e, t, a)=>{
                a ? e.setAttribute(t, a) : e.removeAttribute(t);
            })(e, t, a[t]);
        });
    }, U = (e, t, a)=>{
        x(e, t.class_applied), I(e, b), a && (t.unobserve_completed && M(e, t), w(t.callback_applied, e, a));
    }, $ = (e, t, a)=>{
        x(e, t.class_loading), I(e, u), a && (z(a, 1), w(t.callback_loading, e, a));
    }, q = (e, t, a)=>{
        a && e.setAttribute(t, a);
    }, K = (e, t)=>{
        q(e, i, v(e, t.data_sizes)), q(e, r, v(e, t.data_srcset)), q(e, o, v(e, t.data_src));
    }, Q = {
        IMG: (e, t)=>{
            R(e, (e)=>{
                S(e, V), K(e, t);
            }), S(e, V), K(e, t);
        },
        IFRAME: (e, t)=>{
            S(e, D), q(e, o, v(e, t.data_src));
        },
        VIDEO: (e, t)=>{
            G(e, (e)=>{
                S(e, D), q(e, o, v(e, t.data_src));
            }), S(e, H), q(e, d, v(e, t.data_poster)), q(e, o, v(e, t.data_src)), e.load();
        },
        OBJECT: (e, t)=>{
            S(e, F), q(e, _, v(e, t.data_src));
        }
    }, W = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], X = (e, t)=>{
        !t || ((e)=>e.loadingCount > 0)(t) || ((e)=>e.toLoadCount > 0)(t) || w(e.callback_finish, t);
    }, Y = (e, t, a)=>{
        e.addEventListener(t, a), e.llEvLisnrs[t] = a;
    }, Z = (e, t, a)=>{
        e.removeEventListener(t, a);
    }, ee = (e)=>!!e.llEvLisnrs, te = (e)=>{
        if (!ee(e)) return;
        const t = e.llEvLisnrs;
        for(let a in t){
            const n = t[a];
            Z(e, a, n);
        }
        delete e.llEvLisnrs;
    }, ae = (e, t, a)=>{
        ((e)=>{
            delete e.llTempImage;
        })(e), z(a, -1), ((e)=>{
            e && (e.toLoadCount -= 1);
        })(a), C(e, t.class_loading), t.unobserve_completed && M(e, a);
    }, ne = (e, t, a)=>{
        const n = O(e) || e;
        ee(n) || ((e, t, a)=>{
            ee(e) || (e.llEvLisnrs = {});
            const n = "VIDEO" === e.tagName ? "loadeddata" : "load";
            Y(e, n, t), Y(e, "error", a);
        })(n, (s)=>{
            ((e, t, a, n)=>{
                const s = A(t);
                ae(t, a, n), x(t, a.class_loaded), I(t, g), w(a.callback_loaded, t, n), s || X(a, n);
            })(0, e, t, a), te(n);
        }, (s)=>{
            ((e, t, a, n)=>{
                const s = A(t);
                ae(t, a, n), x(t, a.class_error), I(t, h), w(a.callback_error, t, n), a.restore_on_error && P(t, V), s || X(a, n);
            })(0, e, t, a), te(n);
        });
    }, se = (e, t, n)=>{
        ((e)=>W.indexOf(e.tagName) > -1)(e) ? ((e, t, a)=>{
            ne(e, t, a), ((e, t, a)=>{
                const n = Q[e.tagName];
                n && (n(e, t), $(e, t, a));
            })(e, t, a);
        })(e, t, n) : ((e, t, n)=>{
            ((e)=>{
                e.llTempImage = document.createElement("IMG");
            })(e), ne(e, t, n), ((e)=>{
                j(e) || (e[c] = {
                    backgroundImage: e.style.backgroundImage
                });
            })(e), ((e, t, n)=>{
                const s = v(e, t.data_bg), l = v(e, t.data_bg_hidpi), r = a && l ? l : s;
                r && (e.style.backgroundImage = `url("${r}")`, O(e).setAttribute(o, r), $(e, t, n));
            })(e, t, n), ((e, t, n)=>{
                const s = v(e, t.data_bg_multi), l = v(e, t.data_bg_multi_hidpi), o = a && l ? l : s;
                o && (e.style.backgroundImage = o, U(e, t, n));
            })(e, t, n), ((e, t, a)=>{
                const n = v(e, t.data_bg_set);
                if (!n) return;
                let s = n.split("|").map((e)=>`image-set(${e})`);
                e.style.backgroundImage = s.join(), U(e, t, a);
            })(e, t, n);
        })(e, t, n);
    }, le = (e)=>{
        e.removeAttribute(o), e.removeAttribute(r), e.removeAttribute(i);
    }, oe = (e)=>{
        R(e, (e)=>{
            P(e, V);
        }), P(e, V);
    }, re = {
        IMG: oe,
        IFRAME: (e)=>{
            P(e, D);
        },
        VIDEO: (e)=>{
            G(e, (e)=>{
                P(e, D);
            }), P(e, H), e.load();
        },
        OBJECT: (e)=>{
            P(e, F);
        }
    }, ie = (e, t)=>{
        ((e)=>{
            const t = re[e.tagName];
            t ? t(e) : ((e)=>{
                if (!j(e)) return;
                const t = B(e);
                e.style.backgroundImage = t.backgroundImage;
            })(e);
        })(e), ((e, t)=>{
            k(e) || A(e) || (C(e, t.class_entered), C(e, t.class_exited), C(e, t.class_applied), C(e, t.class_loading), C(e, t.class_loaded), C(e, t.class_error));
        })(e, t), y(e), J(e);
    }, de = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], ce = (e)=>e.use_native && "loading" in HTMLImageElement.prototype, _e = (e, t, a)=>{
        e.forEach((e)=>((e)=>e.isIntersecting || e.intersectionRatio > 0)(e) ? ((e, t, a, n)=>{
                const s = ((e)=>L.indexOf(E(e)) >= 0)(e);
                I(e, "entered"), x(e, a.class_entered), C(e, a.class_exited), ((e, t, a)=>{
                    t.unobserve_entered && M(e, a);
                })(e, a, n), w(a.callback_enter, e, t, n), s || se(e, a, n);
            })(e.target, e, t, a) : ((e, t, a, n)=>{
                k(e) || (x(e, a.class_exited), ((e, t, a, n)=>{
                    a.cancel_on_exit && ((e)=>E(e) === u)(e) && "IMG" === e.tagName && (te(e), ((e)=>{
                        R(e, (e)=>{
                            le(e);
                        }), le(e);
                    })(e), oe(e), C(e, a.class_loading), z(n, -1), y(e), w(a.callback_cancel, e, t, n));
                })(e, t, a, n), w(a.callback_exit, e, t, n));
            })(e.target, e, t, a));
    }, ue = (e)=>Array.prototype.slice.call(e), ge = (e)=>e.container.querySelectorAll(e.elements_selector), be = (e)=>((e)=>E(e) === h)(e), he = (e, t)=>((e)=>ue(e).filter(k))(e || ge(t)), me = function(t, a) {
        const n = s(t);
        this._settings = n, this.loadingCount = 0, ((e, t)=>{
            ce(e) || (t._observer = new IntersectionObserver((a)=>{
                _e(a, e, t);
            }, ((e)=>({
                    root: e.container === document ? null : e.container,
                    rootMargin: e.thresholds || e.threshold + "px"
                }))(e)));
        })(n, this), ((t, a)=>{
            e && (a._onlineHandler = ()=>{
                ((e, t)=>{
                    var a;
                    (a = ge(e), ue(a).filter(be)).forEach((t)=>{
                        C(t, e.class_error), y(t);
                    }), t.update();
                })(t, a);
            }, window.addEventListener("online", a._onlineHandler));
        })(n, this), this.update(a);
    };
    return me.prototype = {
        update: function(e) {
            const a = this._settings, n = he(e, a);
            var s, l;
            N(this, n.length), t ? this.loadAll(n) : ce(a) ? ((e, t, a)=>{
                e.forEach((e)=>{
                    -1 !== de.indexOf(e.tagName) && ((e, t, a)=>{
                        e.setAttribute("loading", "lazy"), ne(e, t, a), ((e, t)=>{
                            const a = Q[e.tagName];
                            a && a(e, t);
                        })(e, t), I(e, m);
                    })(e, t, a);
                }), N(a, 0);
            })(n, a, this) : (l = n, ((e)=>{
                e.disconnect();
            })(s = this._observer), ((e, t)=>{
                t.forEach((t)=>{
                    e.observe(t);
                });
            })(s, l));
        },
        destroy: function() {
            this._observer && this._observer.disconnect(), e && window.removeEventListener("online", this._onlineHandler), ge(this._settings).forEach((e)=>{
                J(e);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function(e) {
            const t = this._settings;
            he(e, t).forEach((e)=>{
                M(e, this), se(e, t, this);
            });
        },
        restoreAll: function() {
            const e = this._settings;
            ge(e).forEach((t)=>{
                ie(t, e);
            });
        }
    }, me.load = (e, t)=>{
        const a = s(t);
        se(e, a);
    }, me.resetStatus = (e)=>{
        y(e);
    }, e && ((e, t)=>{
        if (t) {
            if (t.length) for(let a, n = 0; a = t[n]; n += 1)l(e, a);
            else l(e, t);
        }
    })(me, window.lazyLoadOptions), me;
});


// package.json
var $8ecb29f509dc0bd0$var$version = "1.3.8";
// packages/core/src/maths.ts
function $8ecb29f509dc0bd0$var$clamp(min, input, max) {
    return Math.max(min, Math.min(input, max));
}
function $8ecb29f509dc0bd0$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
function $8ecb29f509dc0bd0$var$damp(x, y, lambda, deltaTime) {
    return $8ecb29f509dc0bd0$var$lerp(x, y, 1 - Math.exp(-lambda * deltaTime));
}
function $8ecb29f509dc0bd0$var$modulo(n, d) {
    return (n % d + d) % d;
}
// packages/core/src/animate.ts
var $8ecb29f509dc0bd0$var$Animate = class {
    isRunning = false;
    value = 0;
    from = 0;
    to = 0;
    currentTime = 0;
    // These are instanciated in the fromTo method
    lerp;
    duration;
    easing;
    onUpdate;
    /**
   * Advance the animation by the given delta time
   *
   * @param deltaTime - The time in seconds to advance the animation
   */ advance(deltaTime) {
        if (!this.isRunning) return;
        let completed = false;
        if (this.duration && this.easing) {
            this.currentTime += deltaTime;
            const linearProgress = $8ecb29f509dc0bd0$var$clamp(0, this.currentTime / this.duration, 1);
            completed = linearProgress >= 1;
            const easedProgress = completed ? 1 : this.easing(linearProgress);
            this.value = this.from + (this.to - this.from) * easedProgress;
        } else if (this.lerp) {
            this.value = $8ecb29f509dc0bd0$var$damp(this.value, this.to, this.lerp * 60, deltaTime);
            if (Math.round(this.value) === this.to) {
                this.value = this.to;
                completed = true;
            }
        } else {
            this.value = this.to;
            completed = true;
        }
        if (completed) this.stop();
        this.onUpdate?.(this.value, completed);
    }
    /** Stop the animation */ stop() {
        this.isRunning = false;
    }
    /**
   * Set up the animation from a starting value to an ending value
   * with optional parameters for lerping, duration, easing, and onUpdate callback
   *
   * @param from - The starting value
   * @param to - The ending value
   * @param options - Options for the animation
   */ fromTo(from, to, { lerp: lerp2, duration: duration, easing: easing, onStart: onStart, onUpdate: onUpdate }) {
        this.from = this.value = from;
        this.to = to;
        this.lerp = lerp2;
        this.duration = duration;
        this.easing = easing;
        this.currentTime = 0;
        this.isRunning = true;
        onStart?.();
        this.onUpdate = onUpdate;
    }
};
// packages/core/src/debounce.ts
function $8ecb29f509dc0bd0$var$debounce(callback, delay) {
    let timer;
    return function(...args) {
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = void 0;
            callback.apply(context, args);
        }, delay);
    };
}
// packages/core/src/dimensions.ts
var $8ecb29f509dc0bd0$var$Dimensions = class {
    constructor(wrapper, content, { autoResize: autoResize = true, debounce: debounceValue = 250 } = {}){
        this.wrapper = wrapper;
        this.content = content;
        if (autoResize) {
            this.debouncedResize = $8ecb29f509dc0bd0$var$debounce(this.resize, debounceValue);
            if (this.wrapper instanceof Window) window.addEventListener("resize", this.debouncedResize, false);
            else {
                this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
                this.wrapperResizeObserver.observe(this.wrapper);
            }
            this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
            this.contentResizeObserver.observe(this.content);
        }
        this.resize();
    }
    width = 0;
    height = 0;
    scrollHeight = 0;
    scrollWidth = 0;
    // These are instanciated in the constructor as they need information from the options
    debouncedResize;
    wrapperResizeObserver;
    contentResizeObserver;
    destroy() {
        this.wrapperResizeObserver?.disconnect();
        this.contentResizeObserver?.disconnect();
        if (this.wrapper === window && this.debouncedResize) window.removeEventListener("resize", this.debouncedResize, false);
    }
    resize = ()=>{
        this.onWrapperResize();
        this.onContentResize();
    };
    onWrapperResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        } else {
            this.width = this.wrapper.clientWidth;
            this.height = this.wrapper.clientHeight;
        }
    };
    onContentResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.scrollHeight = this.content.scrollHeight;
            this.scrollWidth = this.content.scrollWidth;
        } else {
            this.scrollHeight = this.wrapper.scrollHeight;
            this.scrollWidth = this.wrapper.scrollWidth;
        }
    };
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
};
// packages/core/src/emitter.ts
var $8ecb29f509dc0bd0$var$Emitter = class {
    events = {};
    /**
   * Emit an event with the given data
   * @param event Event name
   * @param args Data to pass to the event handlers
   */ emit(event, ...args) {
        let callbacks = this.events[event] || [];
        for(let i = 0, length = callbacks.length; i < length; i++)callbacks[i]?.(...args);
    }
    /**
   * Add a callback to the event
   * @param event Event name
   * @param cb Callback function
   * @returns Unsubscribe function
   */ on(event, cb) {
        this.events[event]?.push(cb) || (this.events[event] = [
            cb
        ]);
        return ()=>{
            this.events[event] = this.events[event]?.filter((i)=>cb !== i);
        };
    }
    /**
   * Remove a callback from the event
   * @param event Event name
   * @param callback Callback function
   */ off(event, callback) {
        this.events[event] = this.events[event]?.filter((i)=>callback !== i);
    }
    /**
   * Remove all event listeners and clean up
   */ destroy() {
        this.events = {};
    }
};
// packages/core/src/virtual-scroll.ts
var $8ecb29f509dc0bd0$var$LINE_HEIGHT = 100 / 6;
var $8ecb29f509dc0bd0$var$listenerOptions = {
    passive: false
};
var $8ecb29f509dc0bd0$var$VirtualScroll = class {
    constructor(element, options = {
        wheelMultiplier: 1,
        touchMultiplier: 1
    }){
        this.element = element;
        this.options = options;
        window.addEventListener("resize", this.onWindowResize, false);
        this.onWindowResize();
        this.element.addEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$listenerOptions);
    }
    touchStart = {
        x: 0,
        y: 0
    };
    lastDelta = {
        x: 0,
        y: 0
    };
    window = {
        width: 0,
        height: 0
    };
    emitter = new $8ecb29f509dc0bd0$var$Emitter();
    /**
   * Add an event listener for the given event and callback
   *
   * @param event Event name
   * @param callback Callback function
   */ on(event, callback) {
        return this.emitter.on(event, callback);
    }
    /** Remove all event listeners and clean up */ destroy() {
        this.emitter.destroy();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.element.removeEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$listenerOptions);
    }
    /**
   * Event handler for 'touchstart' event
   *
   * @param event Touch event
   */ onTouchStart = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: 0,
            y: 0
        };
        this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event: event
        });
    };
    /** Event handler for 'touchmove' event */ onTouchMove = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
        const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: deltaX,
            y: deltaY
        };
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onTouchEnd = (event)=>{
        this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: event
        });
    };
    /** Event handler for 'wheel' event */ onWheel = (event)=>{
        let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
        const multiplierX = deltaMode === 1 ? $8ecb29f509dc0bd0$var$LINE_HEIGHT : deltaMode === 2 ? this.window.width : 1;
        const multiplierY = deltaMode === 1 ? $8ecb29f509dc0bd0$var$LINE_HEIGHT : deltaMode === 2 ? this.window.height : 1;
        deltaX *= multiplierX;
        deltaY *= multiplierY;
        deltaX *= this.options.wheelMultiplier;
        deltaY *= this.options.wheelMultiplier;
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onWindowResize = ()=>{
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
};
// packages/core/src/lenis.ts
var $8ecb29f509dc0bd0$var$defaultEasing = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t));
var $8ecb29f509dc0bd0$export$2e2bcd8739ae039 = class {
    _isScrolling = false;
    // true when scroll is animating
    _isStopped = false;
    // true if user should not be able to scroll - enable/disable programmatically
    _isLocked = false;
    // same as isStopped but enabled/disabled when scroll reaches target
    _preventNextNativeScrollEvent = false;
    _resetVelocityTimeout = null;
    __rafID = null;
    /**
   * Whether or not the user is touching the screen
   */ isTouching;
    /**
   * The time in ms since the lenis instance was created
   */ time = 0;
    /**
   * User data that will be forwarded through the scroll event
   *
   * @example
   * lenis.scrollTo(100, {
   *   userData: {
   *     foo: 'bar'
   *   }
   * })
   */ userData = {};
    /**
   * The last velocity of the scroll
   */ lastVelocity = 0;
    /**
   * The current velocity of the scroll
   */ velocity = 0;
    /**
   * The direction of the scroll
   */ direction = 0;
    /**
   * The options passed to the lenis instance
   */ options;
    /**
   * The target scroll value
   */ targetScroll;
    /**
   * The animated scroll value
   */ animatedScroll;
    // These are instanciated here as they don't need information from the options
    animate = new $8ecb29f509dc0bd0$var$Animate();
    emitter = new $8ecb29f509dc0bd0$var$Emitter();
    // These are instanciated in the constructor as they need information from the options
    dimensions;
    // This is not private because it's used in the Snap class
    virtualScroll;
    constructor({ wrapper: wrapper = window, content: content = document.documentElement, eventsTarget: eventsTarget = wrapper, smoothWheel: smoothWheel = true, syncTouch: syncTouch = false, syncTouchLerp: syncTouchLerp = 0.075, touchInertiaExponent: touchInertiaExponent = 1.7, duration: duration, easing: // in seconds
    easing, lerp: lerp2 = 0.1, infinite: infinite = false, orientation: orientation = "vertical", gestureOrientation: // vertical, horizontal
    gestureOrientation = "vertical", touchMultiplier: // vertical, horizontal, both
    touchMultiplier = 1, wheelMultiplier: wheelMultiplier = 1, autoResize: autoResize = true, prevent: prevent, virtualScroll: virtualScroll, overscroll: overscroll = true, autoRaf: autoRaf = false, anchors: anchors = false, autoToggle: autoToggle = false, allowNestedScroll: // https://caniuse.com/?search=transition-behavior
    allowNestedScroll = false, __experimental__naiveDimensions: __experimental__naiveDimensions = false } = {}){
        window.lenisVersion = $8ecb29f509dc0bd0$var$version;
        if (!wrapper || wrapper === document.documentElement) wrapper = window;
        if (typeof duration === "number" && typeof easing !== "function") easing = $8ecb29f509dc0bd0$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.options = {
            wrapper: wrapper,
            content: content,
            eventsTarget: eventsTarget,
            smoothWheel: smoothWheel,
            syncTouch: syncTouch,
            syncTouchLerp: syncTouchLerp,
            touchInertiaExponent: touchInertiaExponent,
            duration: duration,
            easing: easing,
            lerp: lerp2,
            infinite: infinite,
            gestureOrientation: gestureOrientation,
            orientation: orientation,
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier,
            autoResize: autoResize,
            prevent: prevent,
            virtualScroll: virtualScroll,
            overscroll: overscroll,
            autoRaf: autoRaf,
            anchors: anchors,
            autoToggle: autoToggle,
            allowNestedScroll: allowNestedScroll,
            __experimental__naiveDimensions: __experimental__naiveDimensions
        };
        this.dimensions = new $8ecb29f509dc0bd0$var$Dimensions(wrapper, content, {
            autoResize: autoResize
        });
        this.updateClassName();
        this.targetScroll = this.animatedScroll = this.actualScroll;
        this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        if (this.options.anchors && this.options.wrapper === window) this.options.wrapper.addEventListener("click", this.onClick, false);
        this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, false);
        this.virtualScroll = new $8ecb29f509dc0bd0$var$VirtualScroll(eventsTarget, {
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier
        });
        this.virtualScroll.on("scroll", this.onVirtualScroll);
        if (this.options.autoToggle) this.rootElement.addEventListener("transitionend", this.onTransitionEnd, {
            passive: true
        });
        if (this.options.autoRaf) this.__rafID = requestAnimationFrame(this.raf);
    }
    /**
   * Destroy the lenis instance, remove all event listeners and clean up the class name
   */ destroy() {
        this.emitter.destroy();
        this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, false);
        if (this.options.anchors && this.options.wrapper === window) this.options.wrapper.removeEventListener("click", this.onClick, false);
        this.virtualScroll.destroy();
        this.dimensions.destroy();
        this.cleanUpClassName();
        if (this.__rafID) cancelAnimationFrame(this.__rafID);
    }
    on(event, callback) {
        return this.emitter.on(event, callback);
    }
    off(event, callback) {
        return this.emitter.off(event, callback);
    }
    onScrollEnd = (e)=>{
        if (!(e instanceof CustomEvent)) {
            if (this.isScrolling === "smooth" || this.isScrolling === false) e.stopPropagation();
        }
    };
    dispatchScrollendEvent = ()=>{
        this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", {
            bubbles: this.options.wrapper === window,
            // cancelable: false,
            detail: {
                lenisScrollEnd: true
            }
        }));
    };
    onTransitionEnd = (event)=>{
        if (event.propertyName.includes("overflow")) {
            const property = this.isHorizontal ? "overflow-x" : "overflow-y";
            const overflow = getComputedStyle(this.rootElement)[property];
            if ([
                "hidden",
                "clip"
            ].includes(overflow)) this.internalStop();
            else this.internalStart();
        }
    };
    setScroll(scroll) {
        if (this.isHorizontal) this.options.wrapper.scrollTo({
            left: scroll,
            behavior: "instant"
        });
        else this.options.wrapper.scrollTo({
            top: scroll,
            behavior: "instant"
        });
    }
    onClick = (event)=>{
        const path = event.composedPath();
        const anchor = path.find((node)=>node instanceof HTMLAnchorElement && (node.getAttribute("href")?.startsWith("#") || node.getAttribute("href")?.startsWith("/#") || node.getAttribute("href")?.startsWith("./#")));
        if (anchor) {
            const id = anchor.getAttribute("href");
            if (id) {
                const options = typeof this.options.anchors === "object" && this.options.anchors ? this.options.anchors : void 0;
                let target = `#${id.split("#")[1]}`;
                if ([
                    "#",
                    "/#",
                    "./#",
                    "#top",
                    "/#top",
                    "./#top"
                ].includes(id)) target = 0;
                this.scrollTo(target, options);
            }
        }
    };
    onPointerDown = (event)=>{
        if (event.button === 1) this.reset();
    };
    onVirtualScroll = (data)=>{
        if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false) return;
        const { deltaX: deltaX, deltaY: deltaY, event: event } = data;
        this.emitter.emit("virtual-scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
        if (event.ctrlKey) return;
        if (event.lenisStopPropagation) return;
        const isTouch = event.type.includes("touch");
        const isWheel = event.type.includes("wheel");
        this.isTouching = event.type === "touchstart" || event.type === "touchmove";
        const isClickOrTap = deltaX === 0 && deltaY === 0;
        const isTapToStop = this.options.syncTouch && isTouch && event.type === "touchstart" && isClickOrTap && !this.isStopped && !this.isLocked;
        if (isTapToStop) {
            this.reset();
            return;
        }
        const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
        if (isClickOrTap || isUnknownGesture) return;
        let composedPath = event.composedPath();
        composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
        const prevent = this.options.prevent;
        if (!!composedPath.find((node)=>node instanceof HTMLElement && (typeof prevent === "function" && prevent?.(node) || node.hasAttribute?.("data-lenis-prevent") || isTouch && node.hasAttribute?.("data-lenis-prevent-touch") || isWheel && node.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.checkNestedScroll(node, {
                deltaX: deltaX,
                deltaY: deltaY
            })))) return;
        if (this.isStopped || this.isLocked) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        const isSmooth = this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel;
        if (!isSmooth) {
            this.isScrolling = "native";
            this.animate.stop();
            event.lenisStopPropagation = true;
            return;
        }
        let delta = deltaY;
        if (this.options.gestureOrientation === "both") delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
        else if (this.options.gestureOrientation === "horizontal") delta = deltaX;
        if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) event.lenisStopPropagation = true;
        if (event.cancelable) event.preventDefault();
        const isSyncTouch = isTouch && this.options.syncTouch;
        const isTouchEnd = isTouch && event.type === "touchend";
        const hasTouchInertia = isTouchEnd;
        if (hasTouchInertia) delta = Math.sign(this.velocity) * Math.pow(Math.abs(this.velocity), this.options.touchInertiaExponent);
        this.scrollTo(this.targetScroll + delta, {
            programmatic: false,
            ...isSyncTouch ? {
                lerp: hasTouchInertia ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }
        });
    };
    /**
   * Force lenis to recalculate the dimensions
   */ resize() {
        this.dimensions.resize();
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.emit();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    onNativeScroll = ()=>{
        if (this._resetVelocityTimeout !== null) {
            clearTimeout(this._resetVelocityTimeout);
            this._resetVelocityTimeout = null;
        }
        if (this._preventNextNativeScrollEvent) {
            this._preventNextNativeScrollEvent = false;
            return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
            const lastScroll = this.animatedScroll;
            this.animatedScroll = this.targetScroll = this.actualScroll;
            this.lastVelocity = this.velocity;
            this.velocity = this.animatedScroll - lastScroll;
            this.direction = Math.sign(this.animatedScroll - lastScroll);
            if (!this.isStopped) this.isScrolling = "native";
            this.emit();
            if (this.velocity !== 0) this._resetVelocityTimeout = setTimeout(()=>{
                this.lastVelocity = this.velocity;
                this.velocity = 0;
                this.isScrolling = false;
                this.emit();
            }, 400);
        }
    };
    reset() {
        this.isLocked = false;
        this.isScrolling = false;
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.lastVelocity = this.velocity = 0;
        this.animate.stop();
    }
    /**
   * Start lenis scroll after it has been stopped
   */ start() {
        if (!this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.removeProperty("overflow");
            return;
        }
        this.internalStart();
    }
    internalStart() {
        if (!this.isStopped) return;
        this.reset();
        this.isStopped = false;
        this.emit();
    }
    /**
   * Stop lenis scroll
   */ stop() {
        if (this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.setProperty("overflow", "clip");
            return;
        }
        this.internalStop();
    }
    internalStop() {
        if (this.isStopped) return;
        this.reset();
        this.isStopped = true;
        this.emit();
    }
    /**
   * RequestAnimationFrame for lenis
   *
   * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
   */ raf = (time)=>{
        const deltaTime = time - (this.time || time);
        this.time = time;
        this.animate.advance(deltaTime * 1e-3);
        if (this.options.autoRaf) this.__rafID = requestAnimationFrame(this.raf);
    };
    /**
   * Scroll to a target value
   *
   * @param target The target value to scroll to
   * @param options The options for the scroll
   *
   * @example
   * lenis.scrollTo(100, {
   *   offset: 100,
   *   duration: 1,
   *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
   *   lerp: 0.1,
   *   onStart: () => {
   *     console.log('onStart')
   *   },
   *   onComplete: () => {
   *     console.log('onComplete')
   *   },
   * })
   */ scrollTo(target, { offset: offset = 0, immediate: immediate = false, lock: lock = false, duration: duration = this.options.duration, easing: easing = this.options.easing, lerp: lerp2 = this.options.lerp, onStart: onStart, onComplete: onComplete, force: force = false, programmatic: // scroll even if stopped
    programmatic = true, userData: // called from outside of the class
    userData } = {}) {
        if ((this.isStopped || this.isLocked) && !force) return;
        if (typeof target === "string" && [
            "top",
            "left",
            "start"
        ].includes(target)) target = 0;
        else if (typeof target === "string" && [
            "bottom",
            "right",
            "end"
        ].includes(target)) target = this.limit;
        else {
            let node;
            if (typeof target === "string") node = document.querySelector(target);
            else if (target instanceof HTMLElement && target?.nodeType) node = target;
            if (node) {
                if (this.options.wrapper !== window) {
                    const wrapperRect = this.rootElement.getBoundingClientRect();
                    offset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
                }
                const rect = node.getBoundingClientRect();
                target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll;
            }
        }
        if (typeof target !== "number") return;
        target += offset;
        target = Math.round(target);
        if (this.options.infinite) {
            if (programmatic) {
                this.targetScroll = this.animatedScroll = this.scroll;
                const distance = target - this.animatedScroll;
                if (distance > this.limit / 2) target = target - this.limit;
                else if (distance < -this.limit / 2) target = target + this.limit;
            }
        } else target = $8ecb29f509dc0bd0$var$clamp(0, target, this.limit);
        if (target === this.targetScroll) {
            onStart?.(this);
            onComplete?.(this);
            return;
        }
        this.userData = userData ?? {};
        if (immediate) {
            this.animatedScroll = this.targetScroll = target;
            this.setScroll(this.scroll);
            this.reset();
            this.preventNextNativeScrollEvent();
            this.emit();
            onComplete?.(this);
            this.userData = {};
            requestAnimationFrame(()=>{
                this.dispatchScrollendEvent();
            });
            return;
        }
        if (!programmatic) this.targetScroll = target;
        if (typeof duration === "number" && typeof easing !== "function") easing = $8ecb29f509dc0bd0$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.animate.fromTo(this.animatedScroll, target, {
            duration: duration,
            easing: easing,
            lerp: lerp2,
            onStart: ()=>{
                if (lock) this.isLocked = true;
                this.isScrolling = "smooth";
                onStart?.(this);
            },
            onUpdate: (value, completed)=>{
                this.isScrolling = "smooth";
                this.lastVelocity = this.velocity;
                this.velocity = value - this.animatedScroll;
                this.direction = Math.sign(this.velocity);
                this.animatedScroll = value;
                this.setScroll(this.scroll);
                if (programmatic) this.targetScroll = value;
                if (!completed) this.emit();
                if (completed) {
                    this.reset();
                    this.emit();
                    onComplete?.(this);
                    this.userData = {};
                    requestAnimationFrame(()=>{
                        this.dispatchScrollendEvent();
                    });
                    this.preventNextNativeScrollEvent();
                }
            }
        });
    }
    preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = true;
        requestAnimationFrame(()=>{
            this._preventNextNativeScrollEvent = false;
        });
    }
    checkNestedScroll(node, { deltaX: deltaX, deltaY: deltaY }) {
        const time = Date.now();
        const cache = node._lenis ??= {};
        let hasOverflowX, hasOverflowY, isScrollableX, isScrollableY, scrollWidth, scrollHeight, clientWidth, clientHeight;
        const gestureOrientation = this.options.gestureOrientation;
        if (time - (cache.time ?? 0) > 2e3) {
            cache.time = Date.now();
            const computedStyle = window.getComputedStyle(node);
            cache.computedStyle = computedStyle;
            const overflowXString = computedStyle.overflowX;
            const overflowYString = computedStyle.overflowY;
            hasOverflowX = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowXString);
            hasOverflowY = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowYString);
            cache.hasOverflowX = hasOverflowX;
            cache.hasOverflowY = hasOverflowY;
            if (!hasOverflowX && !hasOverflowY) return false;
            if (gestureOrientation === "vertical" && !hasOverflowY) return false;
            if (gestureOrientation === "horizontal" && !hasOverflowX) return false;
            scrollWidth = node.scrollWidth;
            scrollHeight = node.scrollHeight;
            clientWidth = node.clientWidth;
            clientHeight = node.clientHeight;
            isScrollableX = scrollWidth > clientWidth;
            isScrollableY = scrollHeight > clientHeight;
            cache.isScrollableX = isScrollableX;
            cache.isScrollableY = isScrollableY;
            cache.scrollWidth = scrollWidth;
            cache.scrollHeight = scrollHeight;
            cache.clientWidth = clientWidth;
            cache.clientHeight = clientHeight;
        } else {
            isScrollableX = cache.isScrollableX;
            isScrollableY = cache.isScrollableY;
            hasOverflowX = cache.hasOverflowX;
            hasOverflowY = cache.hasOverflowY;
            scrollWidth = cache.scrollWidth;
            scrollHeight = cache.scrollHeight;
            clientWidth = cache.clientWidth;
            clientHeight = cache.clientHeight;
        }
        if (!hasOverflowX && !hasOverflowY || !isScrollableX && !isScrollableY) return false;
        if (gestureOrientation === "vertical" && (!hasOverflowY || !isScrollableY)) return false;
        if (gestureOrientation === "horizontal" && (!hasOverflowX || !isScrollableX)) return false;
        let orientation;
        if (gestureOrientation === "horizontal") orientation = "x";
        else if (gestureOrientation === "vertical") orientation = "y";
        else {
            const isScrollingX = deltaX !== 0;
            const isScrollingY = deltaY !== 0;
            if (isScrollingX && hasOverflowX && isScrollableX) orientation = "x";
            if (isScrollingY && hasOverflowY && isScrollableY) orientation = "y";
        }
        if (!orientation) return false;
        let scroll, maxScroll, delta, hasOverflow, isScrollable;
        if (orientation === "x") {
            scroll = node.scrollLeft;
            maxScroll = scrollWidth - clientWidth;
            delta = deltaX;
            hasOverflow = hasOverflowX;
            isScrollable = isScrollableX;
        } else if (orientation === "y") {
            scroll = node.scrollTop;
            maxScroll = scrollHeight - clientHeight;
            delta = deltaY;
            hasOverflow = hasOverflowY;
            isScrollable = isScrollableY;
        } else return false;
        const willScroll = delta > 0 ? scroll < maxScroll : scroll > 0;
        return willScroll && hasOverflow && isScrollable;
    }
    /**
   * The root element on which lenis is instanced
   */ get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    /**
   * The limit which is the maximum scroll value
   */ get limit() {
        if (this.options.__experimental__naiveDimensions) {
            if (this.isHorizontal) return this.rootElement.scrollWidth - this.rootElement.clientWidth;
            else return this.rootElement.scrollHeight - this.rootElement.clientHeight;
        } else return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    /**
   * Whether or not the scroll is horizontal
   */ get isHorizontal() {
        return this.options.orientation === "horizontal";
    }
    /**
   * The actual scroll value
   */ get actualScroll() {
        const wrapper = this.options.wrapper;
        return this.isHorizontal ? wrapper.scrollX ?? wrapper.scrollLeft : wrapper.scrollY ?? wrapper.scrollTop;
    }
    /**
   * The current scroll value
   */ get scroll() {
        return this.options.infinite ? $8ecb29f509dc0bd0$var$modulo(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    /**
   * The progress of the scroll relative to the limit
   */ get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    /**
   * Current scroll state
   */ get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(value) {
        if (this._isScrolling !== value) {
            this._isScrolling = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is stopped
   */ get isStopped() {
        return this._isStopped;
    }
    set isStopped(value) {
        if (this._isStopped !== value) {
            this._isStopped = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is locked
   */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        if (this._isLocked !== value) {
            this._isLocked = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is smooth scrolling
   */ get isSmooth() {
        return this.isScrolling === "smooth";
    }
    /**
   * The class name applied to the wrapper element
   */ get className() {
        let className = "lenis";
        if (this.options.autoToggle) className += " lenis-autoToggle";
        if (this.isStopped) className += " lenis-stopped";
        if (this.isLocked) className += " lenis-locked";
        if (this.isScrolling) className += " lenis-scrolling";
        if (this.isScrolling === "smooth") className += " lenis-smooth";
        return className;
    }
    updateClassName() {
        this.cleanUpClassName();
        this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
};


const $77c457e7c2edad9c$export$a97227d03b407136 = ()=>{
    $77c457e7c2edad9c$var$addClassesToHTML();
    $77c457e7c2edad9c$var$addTargetBlank();
    $77c457e7c2edad9c$var$addVHandVWValues();
    // addFigmaGrid();
    $77c457e7c2edad9c$var$addLazyLoad();
    $77c457e7c2edad9c$var$addLenis();
    $77c457e7c2edad9c$var$addToggleNewsletterForm();
    $77c457e7c2edad9c$var$addToggleLegalPopup();
};
const $77c457e7c2edad9c$var$addClassesToHTML = ()=>{
    const isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iP(ad|hone)/i);
    const webkit = !!ua.match(/WebKit/i);
    const isiOS = iOS && webkit && !ua.match(/CriOS/i);
    const touch = isTouch ? "touch" : "no-touch";
    const os = isiOS ? "ios" : "no-ios";
    document.documentElement.classList.remove("touch", "no-touch", "ios", "no-ios");
    document.documentElement.classList.add(touch, os);
};
const $77c457e7c2edad9c$var$addTargetBlank = ()=>{
    const links = document.querySelectorAll("a");
    links.forEach((link)=>{
        if (link.target) return;
        else if (link.host !== window.location.host) {
            link.target = "_blank";
            link.rel = "noopener";
        } else link.target = "_self";
    });
};
const $77c457e7c2edad9c$var$addVHandVWValues = ()=>{
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    const vw = window.innerWidth * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    window.addEventListener("resize", ()=>{
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
        const vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty("--vw", `${vw}px`);
    });
};
function $77c457e7c2edad9c$var$addFigmaGrid() {
    let gridVisible = false;
    const isFigma = document.querySelector(".figma-grid");
    if (isFigma) return; // Figma grid already exists
    const gridContainer = document.createElement("div");
    gridContainer.style.display = "none";
    gridContainer.classList.add("figma-grid");
    const createGrid = ()=>{
        const isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
        const columns = isMobile ? 1 : 3;
        const columnWidth = 100 / columns;
        gridContainer.innerHTML = ""; // Clear existing grid
        for(let i = 0; i < columns; i++){
            const column = document.createElement("div");
            column.classList.add("figma-grid-column");
            column.style.width = `${columnWidth}%`;
            gridContainer.appendChild(column);
        }
    };
    createGrid();
    window.addEventListener("resize", createGrid);
    document.body.appendChild(gridContainer);
    // Press g to toggle the grid
    window.addEventListener("keydown", (e)=>{
        if (e.key === "g") {
            gridVisible = !gridVisible;
            gridContainer.style.display = gridVisible ? "flex" : "none";
        }
    });
}
const $77c457e7c2edad9c$var$addLazyLoad = ()=>{
    var lazyLoadInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($03d2e5de506255f0$exports)))();
};
const $77c457e7c2edad9c$var$addLenis = ()=>{
    const lenis = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)();
    // Listen for the scroll event and update header visibility using Lenis
    lenis.on("scroll", (e)=>{
        $77c457e7c2edad9c$var$addVideoParallax(e);
        $77c457e7c2edad9c$var$updateHeaderVisibleWhileTop(lenis);
    });
    // Use requestAnimationFrame to continuously update the scroll
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
};
const $77c457e7c2edad9c$var$addVideoParallax = (lenis)=>{
    const video = document.querySelector("video");
    if (!video) return;
    const y = lenis.animatedScroll;
    video.style.transform = `translate(0px, ${y}px)`;
};
// Update header visibility using Lenis scroll position
const $77c457e7c2edad9c$var$updateHeaderVisibleWhileTop = (lenis)=>{
    const header = document.querySelector("header");
    if (!header) return;
    // Use Lenis scroll value if available, fallback to window.scrollY
    const isTop = (lenis.scroll !== undefined ? lenis.scroll : window.scrollY) <= 64;
    if (isTop) header.classList.remove("no-visible");
    else header.classList.add("no-visible");
};
const $77c457e7c2edad9c$var$addToggleNewsletterForm = ()=>{
    const form = document.querySelector(".klaviyo-form-UHGQNJ");
    if (!form) return;
    form.classList.add("hidden");
    const newsletterButton = document.querySelector(".newsletter");
    if (!newsletterButton) return;
    const instagram = document.querySelector(".instagram");
    const whatsapp = document.querySelector(".whatsapp");
    const paragraph = document.querySelector(".content_container .paragraph");
    newsletterButton.addEventListener("click", ()=>{
        form.classList.toggle("hidden");
        if (instagram) instagram.classList.toggle("hidden");
        if (whatsapp) whatsapp.classList.toggle("hidden");
        if (paragraph) paragraph.classList.toggle("hidden");
    });
};
const $77c457e7c2edad9c$var$addToggleLegalPopup = ()=>{
    const btn = document.querySelector(".legal_infos");
    if (!btn) return;
    const legalPopup = document.querySelector(".legal_popup");
    if (!legalPopup) return;
    const closeButton = legalPopup.querySelector(".close_popup");
    if (!closeButton) return;
    btn.addEventListener("click", (e)=>{
        e.preventDefault();
        legalPopup.classList.toggle("show");
        console.log("Legal popup toggled");
    });
    closeButton.addEventListener("click", ()=>{
        legalPopup.classList.remove("show");
    });
    // press esc to close the popup
    window.addEventListener("keydown", (e)=>{
        if (e.key === "Escape") legalPopup.classList.remove("show");
    });
};


window.onbeforeunload = function() {
    window.scrollTo(0, 0);
};
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $77c457e7c2edad9c$export$a97227d03b407136)();
});


//# sourceMappingURL=repo.3b61a31b.js.map
